export const SET_EVENT_DATA = "SET_EVENT_DATA"; 
export const setSingleEventData = (eventId, eventSlug, eventTitle) => (
  {
    type: SET_EVENT_DATA,
    payload: {
      eventId,
      eventSlug,
      eventTitle,
    },
});